import { render, staticRenderFns } from "./private-attachments.vue?vue&type=template&id=61e12a81&"
import script from "./private-attachments.vue?vue&type=script&lang=js&"
export * from "./private-attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports